import axios from "axios";
import {
  requestCheckTokenInterceptor,
  logout,
} from "./requestInterceptors/requestCheckTokenInterceptor";

const { REACT_APP_API_URL } = process.env;

const client = axios.create({
  baseURL: REACT_APP_API_URL,
  headers: {
    "response-type": "json",
  },
});
client.interceptors.request.use(
  function (config) {
    config.headers.common.Authorization = `Bearer ${localStorage.getItem(
      "jwt"
    )}`;
    if (config.jwt)
      config.headers.common.Authorization = `Bearer ${
        config.jwt?.jwt || config.jwt
      }`;
    return config;
  },
  function (error) {
    console.log(error);
    return Promise.reject(error);
  }
);

client.interceptors.request.use(
  requestCheckTokenInterceptor(REACT_APP_API_URL),
  function (error) {
    console.log(error);
    return Promise.reject(error);
  }
);

export default client;

function parseError(errorData) {
  let message;
  let type = "general";
  let errors = [];

  const isArray = Array.isArray(errorData.errors);

  if (isArray) {
    errors = errorData.errors;
    type = errors[0].type;
    message = errors[0].error;
  } else {
    message = errorData?.error;
  }

  if (message && typeof message === "string") {
    return { message, type, errors };
  }

  return { message: "GeneralError", type, errors };
}

export const fetcher = async (action, jwt) => {
  try {
    const { data } = await client({ ...(await action), jwt });

    if (data.success === false) {
      throw new ApiError({
        message: data.error,
        status: 400,
        type: "general",
        statusText: "BadRequest",
      });
    }

    return data;
  } catch (error) {
    if (error.isAxiosError && error.response?.status === 401) {
      logout();
    }
    if (error.isAxiosError) {
      const { status, statusText, data: errorData } = error.response ?? {};
      const { message, type, errors } = parseError(errorData);
      // const message = errorData?.error ?? errorData ?? 'GeneralError';

      throw new ApiError({
        message,
        status,
        type,
        statusText,
        errors,
      });
    }

    if (error.name === "ApiError") {
      throw new ApiError(error);
    }
    throw new Error(error.message);
  }
};

class ApiError extends Error {
  constructor({ status, statusText, message, type, ...properties }) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.statusText = statusText;
    this.properties = properties;
    this.type = type;
  }
}
